
import "./MovieDetail.scss";
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {getSelectedMovieOrShow,fetchAsyncMovieOrShowDetail,removeSelectedMovieOrShow} from "../../feature/movies/MovieSlice";

const MovieDetail = () => {
  const {imDbID  }=useParams();
//   console.log("heelojnhhhu",imDbID
//   );
  const disPatch =useDispatch();
  const data = useSelector(getSelectedMovieOrShow);
  console.log(data);
 
  useEffect(()=>{
       disPatch(fetchAsyncMovieOrShowDetail(imDbID));
      
      //  return( ()=>{
      //   disPatch(removeSelectedMovieOrShow());
      //  })
  },[disPatch,imDbID])
 

  return (
    
    <div className='movie-section'>
      {Object.keys(data).length === 0 ?
      (<div>...Loading</div>)
      :(
      <>
         <div className='section-left'>
           <div className='movie-title'>{data.Title}</div>
           <div className='movie-rating'>
             <span>Imdb Rating <i className='fa fa-star'></i> : {data.imdbRating}</span>
             <span>Imdb Votes <i className='fa fa-thumbs-up'></i> : {data.imdbVotes}</span>
             <span>Imdb RunTime <i className='fa fa-film'></i> : {data.Runtime}</span>
             <span>Imdb year <i className='fa fa-calendar'></i> : {data.Year}</span>
           </div>
           <div className='movie-plot'>{data.Plot}</div>
           <div className='movie-info'>
                <div>
                   <span>Director</span>
                   <span>{data.Director}</span>
                </div>
                <div>
                   <span>Stars</span>
                   <span>{data.Actors}</span>
                </div> <div>
                   <span>Generes</span>
                   <span>{data.Genre}</span>
                </div> <div>
                   <span>Language</span>
                   <span>{data.Language}</span>
                </div> <div>
                   <span>Awards</span>
                   <span>{data.Awards}</span>
                </div>
             </div>
         </div>

         <div className='section-right'>
           <img src={data.Poster} alt={data.Title}></img>
         </div>
    </>
      )}
  </div>
  )
}

export default MovieDetail;